import { PathName } from 'appConstants';

export const links = [
  {
    title: 'Agents_',
    pathName: PathName.Sellers,
  },
  {
    title: 'What_we_offer_',
    pathName: PathName.WhatWeOffer,
  },
  {
    title: 'Connect_with_us_',
    pathName: PathName.ConnectUs,
  },
];
